"use client"

import contentDeliveryNetwork from '@iconify/icons-carbon/content-delivery-network';
import { Box, MenuItem, Popover } from '@mui/material';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { IconifyIcon } from '@larvitu/shared/react/components/ui-iconify-icon';

import { IconButtonAnimate } from '../animate';
// import { Iconify } from '../Iconify';

import type { SxProps } from '@mui/material';
import type React from 'react';

const LANGS = [
  {
    label: 'English',
    value: 'en',
    // icon: 'https://zone-assets-api.vercel.app/assets/icons/flags/ic_flag_en.svg',
    // icon: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/GB.svg',
    icon: '/assets/svgs/GB.svg',
  },
  {
    label: 'German',
    value: 'de',
    // icon: 'https://zone-assets-api.vercel.app/assets/icons/flags/ic_flag_de.svg',
    // icon: 'https://purecatamphetamine.github.io/country-flag-icons/3x2/DE.svg',
    icon: '/assets/svgs/DE.svg',
  },
];

// ----------------------------------------------------------------------

interface Props {
  sx?: SxProps;
}

export function LanguagePopover({ sx }: Props): JSX.Element {
  const { asPath, locale } = useRouter();
  const [currentLang, setCurrentLang] = useState( locale );
  const [open, setOpen] = useState<HTMLElement | null>( null );
  const { i18n } = useTranslation();

  useEffect( () => {
    i18n.changeLanguage( currentLang );
  }, [currentLang, i18n] );

  const handleOpen: React.MouseEventHandler<HTMLElement> = (event) => {
    setOpen( event.currentTarget );
  };

  const handleClose = (): void => {
    setOpen( null );
  };

  const handleChangeLang = (newLang: string): void => {
    handleClose();
    setCurrentLang( newLang );
  };

  return (
    <>
      <IconButtonAnimate color="inherit" onClick={handleOpen} sx={sx}>
        <IconifyIcon
          icon={contentDeliveryNetwork}
          width={20}
          height={20}
        />
      </IconButtonAnimate>

      <Popover
        open={Boolean( open )}
        onClose={handleClose}
        anchorEl={open}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        slotProps={{
          paper: {
            sx: {
              px: 1,
              width: 220,
            },
          }
        }}
        // PaperProps={{
        //   sx: {
        //     px: 1,
        //     width: 220,
        //   },
        // }}
      >
        {LANGS.map((option) => (
          <Link
            key={option.value}
            href={asPath}
            locale={option.value}
            legacyBehavior
          >
            <MenuItem
              selected={option.value === locale}
              onClick={(): void => handleChangeLang( option.value )}
              sx={{ my: 1 }}
            >
              <Box
                component="img"
                alt={option.label}
                src={option.icon}
                sx={{
                  borderRadius: '50%',
                  width: 28,
                  height: 28,
                  objectFit: 'cover',
                  mr: 1,
                }}
              />

              {option.label}
            </MenuItem>
          </Link>
        ))}
      </Popover>
    </>
  );
}
